<template>
  <a
    class="c-newItemAdd"
    :class="{ [`-${type}`]: true }"
    @click="$emit('click')"
  >
    <div class="c-newItemAdd_inner">
      <div class="c-newItemAdd_icon">
        <CoconalaIcon name="plus-circle" :size="`${iconSize}px`" />
      </div>
      <p class="c-newItemAdd_text">{{ text }}</p>
    </div>
  </a>
</template>
<script>
export const TYPES = ['grid', 'list', 'card']

export default {
  name: 'NewItemAdd',
  props: {
    type: {
      type: String,
      default: 'grid'
    },
    text: {
      type: String,
      default: '新しく追加する'
    }
  },
  data() {
    return {
      height: 240
    }
  },
  mounted() {
    setTimeout(this.setHeight, 1)
    this.$util.on('resize', window, this.setHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setHeight)
  },
  methods: {
    setHeight() {
      this.height = this.$el.offsetHeight
    }
  },
  computed: {
    iconSize() {
      return Math.round(this.height * 0.32)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-newItemAdd {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $color-gray-200;
  border-radius: 5px;
  background-color: $color-bg-pale;
  @include link-effect;

  &_inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &_icon {
    color: $color-gray-300;
  }
  &_text {
    font-weight: bold;
    margin: 5% 0 0 0;
  }

  &.-grid {
    // NOTE: なぜかボーダーの分だけ縦に長くなるときが有る
    padding-bottom: calc(100% - 2px);
    .c-newItemAdd {
      &_inner {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }
  }

  &.-list {
    min-height: 150px;
    .c-newItemAdd {
      &_inner {
      }
    }
  }
}
</style>
